import { TDataset, TDatasetLabel, TDatasetSample, TMLModel } from "../../models/aibuilder/aibuilder";
import { useApiClient } from "../apiClients";
import { ENDPOINTS_AIBUILDER } from "./endpoints";

export const useAIBuilderApi = () => {
  const apiClient = useApiClient();

  // Datasets
  const createDataset = (data: Partial<TDataset>) =>
    apiClient.post<TDataset>(ENDPOINTS_AIBUILDER.CREATE_DATASET, data);
  const getDatasetById = (id: number) =>
    apiClient.get<TDataset>(ENDPOINTS_AIBUILDER.GET_DATASET_BY_ID(id));
  const getDatasetsByUserAppId = () =>
    apiClient.get<TDataset[]>(ENDPOINTS_AIBUILDER.GET_DATASETS_BY_USERAPP());
  const updateDataset = (id: number, data: Partial<TDataset>) =>
    apiClient.put<TDataset>(ENDPOINTS_AIBUILDER.UPDATE_DATASET(id), data);
  const deleteDataset = (id: number) =>
    apiClient.delete(ENDPOINTS_AIBUILDER.DELETE_DATASET(id));

  // Labels
  const createLabel = (datasetId: number, data: Partial<TDatasetLabel>) =>
    apiClient.post<TDatasetLabel>(ENDPOINTS_AIBUILDER.CREATE_LABEL(datasetId), data);
  const updateLabel = (id: number, data: Partial<TDatasetLabel>) =>
    apiClient.put<TDatasetLabel>(ENDPOINTS_AIBUILDER.UPDATE_LABEL(id), data);
  const deleteLabel = (id: number) =>
    apiClient.delete(ENDPOINTS_AIBUILDER.DELETE_LABEL(id));

  // Samples : FormData contient "image" et, éventuellement, "label_id".
  const createSampleImage = (datasetId: number, formData: FormData) =>
    apiClient.post<TDatasetSample>(
      ENDPOINTS_AIBUILDER.CREATE_SAMPLE(datasetId),
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  const createSampleText = (datasetId: number, data: { label_id?: number; content_text: string }) =>
    apiClient.post<TDatasetSample>(ENDPOINTS_AIBUILDER.CREATE_SAMPLE(datasetId), data);
  const setSampleExcluded = (id: number, excluded: boolean) =>
    apiClient.patch<{ id: number; excluded: boolean }>(
      ENDPOINTS_AIBUILDER.SET_SAMPLE_EXCLUDED(id),
      { excluded }
    );
  const deleteSample = (id: number) =>
    apiClient.delete(ENDPOINTS_AIBUILDER.DELETE_SAMPLE(id));

  // Models
  const createModel = (datasetId: number, data: Partial<TMLModel>) =>
    apiClient.post<TMLModel>(ENDPOINTS_AIBUILDER.CREATE_MODEL(datasetId), data);
  const getModels = (datasetId: number) =>
    apiClient.get<TMLModel[]>(ENDPOINTS_AIBUILDER.GET_MODELS(datasetId));

  return {
    createDataset,
    getDatasetById,
    getDatasetsByUserAppId,
    updateDataset,
    deleteDataset,
    createLabel,
    updateLabel,
    deleteLabel,
    createSampleImage,
    createSampleText,
    setSampleExcluded,
    deleteSample,
    createModel,
    getModels,
  };
};
